module.exports = __webpack_public_path__ + "img/a012_4.1eae9148.jpeg";